function normalize(value: string): string {
  return value.trim().replace(/\s+/g, ' ').toLocaleLowerCase()
}

export async function sha256Hex(value: string): Promise<string> {
  const bytes = new TextEncoder().encode(value)
  const digest = await crypto.subtle.digest('SHA-256', bytes)
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('')
}

export async function fingerprintBankRow(row: {
  transactionDate: number
  amountCents: number
  otherParty: string
  reference: string
  particulars: string
  analysisCode: string
  description: string
}): Promise<string> {
  return sha256Hex(
    JSON.stringify([
      row.transactionDate,
      row.amountCents,
      normalize(row.otherParty),
      normalize(row.reference),
      normalize(row.particulars),
      normalize(row.analysisCode),
      normalize(row.description),
    ]),
  )
}
